(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["furlabs-offers"] && !Shopify.designMode) return;
  try {
    (() => {
    const qtyInput = () =>
      document.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
    const atcButton = () =>
      document.querySelector('product-form-component [type="submit"], form[action*="/cart/add"] [type="submit"]');

    document.querySelectorAll('.furlabs-offers__tile').forEach((tile) => {
      tile.addEventListener('click', () => {
        const qty = tile.dataset.furlabsQty || '1';
        document.querySelectorAll('.furlabs-offers__tile').forEach((t) => {
          t.classList.toggle('is-selected', t === tile);
          t.setAttribute('aria-pressed', t === tile ? 'true' : 'false');
        });
        const input = qtyInput();
        if (input) {
          input.value = qty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["furlabs-payments"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('furlabs-delivery')) {
    customElements.define(
      'furlabs-delivery',
      class extends HTMLElement {
        connectedCallback() {
          const M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
          const fmt = (d) => d.getDate() + ' ' + M[d.getMonth()];
          const add = (days) => {
            const d = new Date();
            d.setDate(d.getDate() + days);
            return d;
          };
          const ship = parseInt(this.dataset.shipDays || '1', 10);
          const min = parseInt(this.dataset.minDays || '4', 10);
          const max = parseInt(this.dataset.maxDays || '8', 10);
          this.range = fmt(add(min)) + '\u2009\u2013\u2009' + fmt(add(max));
          const set = (sel, text) => {
            const el = this.querySelector(sel);
            if (el) el.textContent = text;
          };
          set('[data-fd-purchase]', fmt(add(0)));
          set('[data-fd-ship]', fmt(add(ship)));
          set('[data-fd-deliver]', this.range);

          const form = this.querySelector('[data-fd-form]');
          const input = this.querySelector('[data-fd-input]');
          const result = this.querySelector('[data-fd-result]');
          if (form && input && result) {
            form.addEventListener('submit', (e) => {
              e.preventDefault();
              const pin = input.value.trim();
              const truck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v10h-11zM13.5 10h4.2l2.8 3v3.5h-7z"/><circle cx="6.6" cy="17.6" r="1.8"/><circle cx="16.9" cy="17.6" r="1.8"/></svg>';
              result.hidden = false;
              result.classList.remove('is-in');
              if (/^[1-9][0-9]{5}$/.test(pin)) {
                result.classList.remove('is-error');
                result.classList.add('is-success');
                result.innerHTML =
                  '<span class="fd-badge">' + truck + '<i class="fd-badge-tick">\u2713</i></span>' +
                  '<span class="fd-lines"><strong>Yes! We deliver to ' + pin + '</strong>' +
                  '<small>Expected <b>' + this.range + '</b> \u00b7 COD &amp; prepaid accepted</small></span>';
              } else {
                result.classList.remove('is-success');
                result.classList.add('is-error');
                result.textContent = 'Please enter a valid 6-digit pincode.';
              }
              void result.offsetWidth;
              result.classList.add('is-in');
            });
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
